import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  BILL_TO_ADDRESS_FIELDS,
  CONTACT_FIELDS,
  INVOICE_DELIVERY_FIELDS
} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages from '..';

type Field = {
  key: string;
};

type Card = {
  key: string;
  hideSameAs?: boolean;
  fields?: Field[];
  fieldWrapper?: string;
};

type PageTemplate = {
  route: string;
  cards: Card[];
};

describe('Bill To Page Template', () => {
  it('exports pages array with one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const billToPage = (pages as PageTemplate[]).find(p => p.route === PAGE_ROUTES.company);

  it('has correct route', () => {
    expect(billToPage).toBeDefined();
    expect(billToPage?.route).toBe(PAGE_ROUTES.company);
  });

  it('contains expected cards', () => {
    expect(Array.isArray(billToPage?.cards)).toBe(true);
    expect(billToPage?.cards.map(c => c.key)).toEqual([
      CARD_CATEGORIES.billTo,
      CARD_CATEGORIES.invoiceDelivery,
      CARD_CATEGORIES.additionalAttachmentCard,
      CARD_CATEGORIES.privacyPolicy
    ]);
  });

  describe('Bill To Card', () => {
    const billToCard = billToPage?.cards.find(c => c.key === CARD_CATEGORIES.billTo);

    it('has hideSameAs enabled', () => {
      expect(billToCard).toBeDefined();
      expect(billToCard?.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(billToCard?.fields?.map(f => f.key)).toEqual([
        BILL_TO_ADDRESS_FIELDS.address,
        BILL_TO_ADDRESS_FIELDS.taxNumber1,
        BILL_TO_ADDRESS_FIELDS.taxNumber2
      ]);
    });
  });

  describe('Invoice Delivery Card', () => {
    const invoiceCard = billToPage?.cards.find(c => c.key === CARD_CATEGORIES.invoiceDelivery);

    it('has correct contact fields and mailToBillTo', () => {
      const keys = invoiceCard?.fields?.map(f => f.key) || [];
      expect(keys).toContain(CONTACT_FIELDS.email);
      expect(keys).toContain(CONTACT_FIELDS.fax);
      expect(keys).toContain(INVOICE_DELIVERY_FIELDS.mailToBillTo);
    });

    it('has correct fieldWrapper', () => {
      expect(invoiceCard?.fieldWrapper).toBe(CARD_CATEGORIES.shipTo + '[0]');
    });
  });

  describe('Attachment & Privacy Cards', () => {
    it('contains additionalAttachmentCard', () => {
      const attachmentCard = billToPage?.cards.find(c => c.key === CARD_CATEGORIES.additionalAttachmentCard);
      expect(attachmentCard).toBeDefined();
      expect(attachmentCard?.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = billToPage?.cards.find(c => c.key === CARD_CATEGORIES.privacyPolicy);
      expect(privacyCard).toBeDefined();
      expect(privacyCard?.fields).toBeUndefined();
    });
  });
});